import { projectRequest } from 'store/utils/request';

export const getNotificationListRequest = async params => {
  try {
    return await projectRequest.get(`/notifications/`, {
      params,
    });
  } catch (error) {
    throw error;
  }
};

export const getNotificationsCountRequest = async () => {
  try {
    return await projectRequest.get(`/notifications/count-unread/`);
  } catch (error) {
    throw error;
  }
};

export const markNotificationsAsRead = async () => {
  try {
    return await projectRequest.post(`/notifications/mark-all-read/`);
  } catch (error) {
    throw error;
  }
};
